module.exports = __webpack_public_path__ + "static/media/icon-alert.871b7f0c.svg";